<div class="registration-container">
  
  <div class="header-row">
    <h3>App registration details</h3>
    <button mat-icon-button (click)="info()" matTooltip="Info">
      <mat-icon class="material-icons-outlined">info</mat-icon>
    </button>
  </div>

  <div class="form-body">
    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput placeholder="Description" [(ngModel)]="appRegistration.description" name="description" autofocus>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Client Id</mat-label>
      <input matInput placeholder="Client Id" [(ngModel)]="appRegistration.clientId" name="clientId">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Client Secret</mat-label>
      <input matInput placeholder="Client Secret" [(ngModel)]="appRegistration.clientSecret" name="clientSecret">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Provider</mat-label>
      <mat-select [(ngModel)]="appRegistration.provider" name="provider" required [compareWith]="functions.objectComparisonFunction">
        <mat-option *ngFor="let provider of providers" [value]="provider">
          {{provider.provider}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Due Date Client Secret</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="appRegistration.dueDateClientSecret" name="dueDateClientSecret">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="actions">
    <button mat-raised-button color="primary" (click)="save()">Save</button>
  </div>

</div>